<template>
  <button 
    class="btn-primary w-[93px]" 
    @click="createAndGoToNewEngagement"
  >
    <font-awesome-icon :icon="['fas', 'plus']" class="h-3 w-3" />
    Create
  </button>
</template>
<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'

library.add(faPlus)

export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    entity_id: { // eslint-disable-line vue/prop-name-casing
      type: [Number, String],
      default: null,
    },
  },
  computed:{
    ...mapGetters('auth',['isAuthenticated','current_user','loading']),
    ...mapGetters('tenant',['current_tenant_slug']),
    isTenantDiverge() {
      return this.current_tenant_slug === 'diverge'
    },
    defaultEngagementChannel() {
      return this.isTenantDiverge ? 1 : 5
    },
    newEngagement(){
      return{
        user:this.current_user,
        entity: this.entity_id ?? null,
        engagement_channel:this.defaultEngagementChannel,
        engagement_topics:[],
        date:new Date().toISOString().split('T')[0]
      }
    }
  },
  methods: {
    createAndGoToNewEngagement(){
      return axios.post('/api/engagements/', this.newEngagement)
        .then(response => {
          this.$router.push({
            name:'Engagement',
            params:{
              engagement_id:response.data.id,

            }})
        })
        .catch(error => {
          console.error('Error creating new engagement:', error)
        })
    },
  }
}

</script>
